import { Injectable ,} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router, CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
  }
  
  @Injectable()
  export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    canDeactivate(component: CanComponentDeactivate, 
             route: ActivatedRouteSnapshot, 
             state: RouterStateSnapshot) {
  
       let url: string = state.url;
       console.log('Url: '+ url);
  
       return component.canDeactivate ? component.canDeactivate() : true;
    }
  }


// WEBPACK FOOTER //
// ./src/app/services/can-deactivate-guard.service.ts